export const DATE_FORMAT = "YYYY-MM-DD"
export const DATE_RANGE_BEFORE = 5
export const DATE_RANGE_AFTER = 5
export const DATE_WINDOW_SIZE = DATE_RANGE_BEFORE + DATE_RANGE_AFTER + 1
export const TOP_PICK_MIN_PROBABILITY = 0.65
export const TOP_PICK_MIN_MARGIN = 0.1
export const HOT_PICK_MIN_MARGIN = 0.15
export const AUSTRALIAN_TIMEZONE = "Australia/Melbourne"